import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, Space } from 'antd';
import { useToast } from '../../../contexts/ToastContext';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';

const { Title } = Typography;

const SettingsTab: React.FC = () => {
  const toast = useToast();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSave = async (values: any) => {
    setLoading(true);
    try {
      // API çağrısı burada yapılacak
      // await apiService.updateAdminSettings(values);
      toast.success('Ayarlar başarıyla kaydedildi');
    } catch (error) {
      toast.error('Ayarlar kaydedilirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
    toast.info('Form sıfırlandı');
  };

  return (
    <div className="panel-tab-content">
      <Title level={2} style={{ marginBottom: '24px' }}>Sistem Ayarları</Title>
      
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave}
        initialValues={{
          siteName: 'Mentor System',
          siteDescription: 'Mentor ve mentee buluşma platformu',
          allowRegistration: true,
          requireEmailVerification: true,
          allowMentorRegistration: true,
          allowMenteeRegistration: true,
          allowCompanyRegistration: true,
          maxMenteesPerMentor: 10,
          sessionTimeout: 30
        }}
      >
        <Card title="Genel Ayarlar" style={{ marginBottom: '24px' }}>
          <Form.Item
            name="siteName"
            label="Site Adı"
            rules={[{ required: true, message: 'Site adı gereklidir' }]}
          >
            <Input placeholder="Site adını girin" />
          </Form.Item>

          <Form.Item
            name="siteDescription"
            label="Site Açıklaması"
            rules={[{ required: true, message: 'Site açıklaması gereklidir' }]}
          >
            <Input.TextArea rows={3} placeholder="Site açıklamasını girin" />
          </Form.Item>
        </Card>


        <Space>
          <Button 
            type="primary" 
            htmlType="submit" 
            icon={<SaveOutlined />}
            loading={loading}
          >
            Kaydet
          </Button>
          <Button 
            icon={<ReloadOutlined />}
            onClick={handleReset}
          >
            Sıfırla
          </Button>
        </Space>
      </Form>
    </div>
  );
};

export default SettingsTab;
